"use client";

import React from "react";
import { Users, House, BookOpen, Sparkles, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
const pathways = [{
  id: 1,
  title: "Employment Law",
  description: "Expert guidance on industrial relations, trade unions, and workplace disputes.",
  icon: "Users",
  link: "/PracticeAreasPage"
}, {
  id: 2,
  title: "Civil Litigation",
  description: "Strategic representation for complex commercial and private legal conflicts.",
  icon: "House",
  link: "/PracticeAreasPage"
}, {
  id: 3,
  title: "Corporate Advisory",
  description: "Comprehensive legal support for business operations and regulatory compliance.",
  icon: "BookOpen",
  link: "/PracticeAreasPage"
}];
const highlights = [{
  pathwayId: 1,
  text: "Industrial Relations"
}, {
  pathwayId: 1,
  text: "Retrenchment Advisory"
}, {
  pathwayId: 1,
  text: "Domestic Inquiries"
}, {
  pathwayId: 2,
  text: "Contractual Disputes"
}, {
  pathwayId: 2,
  text: "Tortious Claims"
}, {
  pathwayId: 2,
  text: "Debt Recovery"
}, {
  pathwayId: 3,
  text: "Conveyancing"
}, {
  pathwayId: 3,
  text: "Shareholder Agreements"
}, {
  pathwayId: 3,
  text: "Risk Management"
}];
const iconMap: Record<string, React.ElementType> = {
  Users,
  House,
  BookOpen
};
export default function LearningPathways() {
  return <section data-section-id="224341" id="core-legal-expertise" className="relative w-full bg-background text-foreground py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-[0.05]" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold font-default text-foreground mb-6 tracking-tight">
            Core Legal Expertise
          </h2>
          <p className="text-lg text-muted-foreground font-default">&nbsp;Shaik Azrin &amp; Co provides precise legal counsel tailored to corporate and individual needs.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {pathways.map((pathway, index) => {
          const Icon = iconMap[pathway.icon];
          const pathwayHighlights = highlights.filter(h => h.pathwayId === pathway.id);
          return <div key={pathway.id} data-index={index} className="group relative rounded-none p-[1px] bg-gradient-to-b from-primary/50 to-transparent overflow-hidden">
                {}
                <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/5 transition-colors duration-700 blur-2xl" />

                <Card className="relative h-full min-h-[420px] bg-card/80 backdrop-blur-xl border border-primary/20 rounded-none transition-all duration-500 group-hover:-translate-y-2 group-hover:shadow-2xl group-hover:shadow-primary/20 flex flex-col overflow-hidden">
                  
                  {}
                  <CardHeader className="flex-1 relative z-10 transition-opacity duration-500 group-hover:opacity-0">
                    <div className="size-16 rounded-none bg-secondary/10 flex items-center justify-center mb-6 border border-primary/30 transition-colors duration-500 group-hover:border-primary">
                      <Icon className="size-8 text-primary" strokeWidth={1} />
                    </div>
                    <span className="text-xs font-mono uppercase tracking-widest text-primary mb-2 block">
                      Practice Area
                    </span>
                    <CardTitle className="text-2xl font-serif text-foreground mb-3">
                      {pathway.title}
                    </CardTitle>
                    <CardDescription className="text-base font-default text-muted-foreground">
                      {pathway.description}
                    </CardDescription>
                  </CardHeader>

                  {}
                  <div className="absolute inset-x-0 top-0 bottom-[80px] z-20 bg-card/95 backdrop-blur-md p-8 flex flex-col justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none">
                    <h4 className="text-lg font-semibold font-serif text-primary mb-6 flex items-center gap-2">
                      <Sparkles className="size-5" /> Key Specializations
                    </h4>
                    <ul className="space-y-4">
                      {pathwayHighlights.map((highlight, hIdx) => <li key={hIdx} data-index={hIdx} className="flex items-center gap-3 text-foreground translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500" style={{
                    transitionDelay: `${hIdx * 150}ms`
                  }}>
                          <div className="size-1.5 rounded-none bg-primary shadow-[0_0_8px_var(--color-primary)]" />
                          <span className="font-default font-medium">{highlight.text}</span>
                        </li>)}
                    </ul>
                  </div>

                  {}
                  <CardFooter className="relative z-30 mt-auto pt-6 border-t border-primary/20 transition-colors duration-500 group-hover:border-primary/50 bg-card/50 backdrop-blur-sm">
                    <Button asChild variant="ghost" className="w-full justify-between group/btn hover:bg-primary/10 hover:text-primary font-mono text-xs uppercase tracking-wider">
                      
                    </Button>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}